
import { MenuStatue } from '../../packages/dist/types'
import { defineComponent, getCurrentInstance } from 'vue'

export default defineComponent({
    name: 'VueDoc',
    data () {
        return {
            popBox: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-popbox'],
            toast: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-toast'],
            menu: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-menu'],
            menuStatue: {
                show: false,
                point: { x: 0, y: 0 }
            } as MenuStatue,
            name: '林槐',
            showFun: true
        }
    },
    methods: {
        showMenu(event: Event, isMe = false) {
            const info = this.menu.set('demo-menu', event as MouseEvent)
            info.list = !isMe ? ['reply', 'copy'] : ['delete', 'copy']
            this.menuStatue = info
        },
        closeMenu(id: string) {
            this.menuStatue.show = false
            if(id != undefined) {
                this.toast.show({
                    icon: 'fa-solid fa-circle-info',
                    text: `${id} 被点击了。`,
                    autoClose: true
                })
            }
        },

        showToast() {
            const textList = [
                ['fa-circle-info', '这是一条吐司消息。'],
                ['fa-bread-slice', '香浓的吐司！'],
                ['fa-gear', '这个吐司看起来有好好初始化哦。'],
                ['fa-ghost', '¯\\_(ツ)_/¯'],
                ['fa-utensils', '来个吐司？'],
                ['fa-face-grin-stars', '吐司超好吃 ——'],
                ['fa-circle-info', '这是个没有感情的吐司。'],
                ['fa-heart', 'Also try LayUI!'],
                ['fa-bread-slice', 'Toast'],
                ['fa-circle-info', '不想说话。'],
                ['fa-circle-info', 'SS!'],
                ['fa-face-grin-squint-tears', '隔壁小孩都馋哭了。'],
                ['fa-fire', '正在烤吐司。'],
                ['fa-wrench', '超文本烤箱控制协议'],
                ['fa-ban', '419 I\'m a Microwave Oven.']
            ]
            // 随机显示
            const index = Math.floor(Math.random() * textList.length)
            const toastInfo = {
                icon: 'fa-solid ' + textList[index][0],
                text: textList[index][1],
                // 随机获取一个 true 或 false
                autoClose: Math.random() > 0.5
            }
            this.toast.show(toastInfo)
        },
        clearToast() {
            this.toast.clear()
        },

        addPop() {
            const textList = [
                '这是一条弹窗消息。',
                '👋，你好啊！',
                '这是一条弹窗消息，这是一条弹窗消息，这是一条弹窗消息。',
                '你好世界！',
                '一个弱小可怜又无助的消息。'
            ]
            // 随机获取三条显示
            for (let i = 0; i < 4; i++) {
                const index = Math.floor(Math.random() * textList.length)
                const popInfo = {
                    title: '你好啊！',
                    icon: 'fa-solid fa-smile',
                    html: `<p>${textList[index]}</p>`,
                    button: [
                        {
                            text: '关闭',
                            master: true,
                            fun: () => this.popBox.remove()
                        }
                    ]
                }
                this.popBox.add(popInfo)
            }
        },
        removeCard() {
            const card = document.getElementById('delCard')
            if (card) {
                card.style.display = 'none'
            }
        }
    }
});
